import React, { useState } from "react";
import "./Qualification.css";

const Qualifiaction = () => {
  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <section className="qualification section" id="qualifications">
      <h2 className="section_title">Qualification</h2>
      <span className="section_subtitle">My Professional & Academic Journey</span>
      <div className="qualification_container container">
        <div className="qualification_tabs">
          <div
            className={
              toggleState === 1
                ? "qualification_button qualification_active button--flex"
                : "qualification_button  button--flex"
            }
            onClick={() => toggleTab(1)}
          >
            <i className="uil uil-briefcase-alt qualification_icon"></i>
            Experience
          </div>

          <div
            className={
              toggleState === 2
                ? "qualification_button qualification_active button--flex"
                : "qualification_button  button--flex"
            }
            onClick={() => toggleTab(2)}
          >
            <i className="uil uil-graduation-cap qualification_icon"></i>
            Education
          </div>
        </div>

        <div className="qualification_sections">
          <div
            className={
              toggleState === 1
                ? "qualification_content qualification_content_active"
                : "qualification_content"
            }
          >
            <div className="qualification_data">
              <div></div>
              <div>
                <span className="qualification_rounder"></span>
                <span className="qualification_line"></span>
              </div>
              <div className="qualification_detail">
                <h3 className="qualification_title">Software Engineer, Android</h3>
                <span className="qualification_subtitle">Meta Platforms, Inc.</span>
                <div className="qualification_calendar">
                  <i className="uil uil-calendar-alt calendar_icon"></i>Nov 2025 - Present
                </div>
              </div>
            </div>
            <div className="qualification_data">
              <div className="qualification_detail">
                <h3 className="qualification_title">Student Software Engineer</h3>
                <span className="qualification_subtitle">National Internet Observatory</span>
                <div className="qualification_calendar">
                  <i className="uil uil-calendar-alt calendar_icon"></i>Jan 2025 - Jun 2025
                </div>
              </div>
              <div>
                <span className="qualification_rounder"></span>
                <span className="qualification_line"></span>
              </div>
            </div>
            <div className="qualification_data">
              <div></div>
              <div>
                <span className="qualification_rounder"></span>
                <span className="qualification_line"></span>
              </div>
              <div className="qualification_detail">
                <h3 className="qualification_title">Android Engineer Co-op</h3>
                <span className="qualification_subtitle">National Internet Observatory</span>
                <div className="qualification_calendar">
                  <i className="uil uil-calendar-alt calendar_icon"></i>Jun 2024 - Dec 2024
                </div>
              </div>
            </div>
            <div className="qualification_data">
              <div className="qualification_detail">
                <h3 className="qualification_title">Associate Engineer</h3>
                <span className="qualification_subtitle">Mutual Mobile</span>
                <div className="qualification_calendar">
                  <i className="uil uil-calendar-alt calendar_icon"></i>Jun 2022 - Aug 2023
                </div>
              </div>
              <div>
                <span className="qualification_rounder"></span>
                <span className="qualification_line"></span>
              </div>
            </div>

            <div className="qualification_data">
              <div></div>
              <div>
                <span className="qualification_rounder"></span>
                <span className="qualification_line"></span>
              </div>
              <div>
                <h3 className="qualification_title">Software Engineer</h3>
                <span className="qualification_subtitle">SpurTree Tech</span>
                <div className="qualification_calendar">
                  <i className="uil uil-calendar-alt calendar_icon"></i>Oct 2021 - June 2022
                </div>
              </div>
            </div>

            <div className="qualification_data">
              <div>
                <h3 className="qualification_title">Jr Software Engineer</h3>
                <span className="qualification_subtitle">Spurtree Tech</span>
                <div className="qualification_calendar">
                  <i className="uil uil-calendar-alt calendar_icon"></i>Oct 2020 - Oct 2021
                </div>
              </div>
              <div>
                <span className="qualification_rounder"></span>
              </div>
            </div>
          </div>
          <div
            className={
              toggleState === 2
                ? "qualification_content qualification_content_active"
                : "qualification_content"
            }
          >
            <div className="qualification_data">
              <div></div>
              <div>
                <span className="qualification_rounder"></span>
                <span className="qualification_line"></span>
              </div>
              <div>
                <h3 className="qualification_title">M.S - Software Engineering Systems</h3>
                <span className="qualification_subtitle">Northeastern University</span>
                <div className="qualification_calendar">
                  <i className="uil uil-calendar-alt calendar_icon"></i>Sept 2023 - Aug 2025
                </div>
              </div>
            </div>

            <div className="qualification_data">
              <div className="qualification_detail">
                <h3 className="qualification_title">B.E - CSE</h3>
                <span className="qualification_subtitle">
                  Vishvesvaraya Technological University
                </span>
                <div className="qualification_calendar">
                  <i className="uil uil-calendar-alt calendar_icon"></i>Aug 2016 - Aug 2020
                </div>
              </div>
              <div>
                <span className="qualification_rounder"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Qualifiaction;
